import React from 'react';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import DocumentList from 'components/common/fields/DocumentList';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

export const ApprovalDocuments = ({ documents }) => path(['length'], documents) > 0 ? (
    <div>
        <DefinitionHeader iconType='text-document'>
            <Translate content="common.attachments" />
        </DefinitionHeader>
        <DocumentList documents={ documents } />
    </div>
) : null;
